module.exports = __webpack_public_path__ + "img/login_logo_120.78728e33.png";